import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Use Grouped Audit Hook
 */

export default () => {
    const { audits, auditLocations } = useSelector((state) => state);

    return useMemo(() => {
        const res = auditLocations.data.filter(
            (item) =>
                item.audit.auditReference === audits.item.auditReference &&
                audits.item.auditReference.toLowerCase() !== "none"
        );
        // filter out audit which are submitted
        const result = res.filter((item) =>
            audits.data.some((audit) => {
                return item.audit.id === audit.id;
            })
        );

        return result;
    }, [audits, auditLocations]);
};
